import React from 'react';
import { Box, Button, Typography } from "@mui/material";

class ConfirmDialog extends React.Component {
    render() {
        const { message, onConfirm, onCancel } = this.props;
        return (
            <Box className="confirm-dialog">
                <Box className="confirm-dialog-content">
                    <Typography component="p">{message}</Typography>
                    <Button onClick={onConfirm}>Yes</Button>
                    <Button onClick={onCancel}>No</Button>
                </Box>
            </Box>
        );
    }
}

export default ConfirmDialog;
